// src/utilies/pageMeta.js
// Bütün public route-lar üçün mərkəzi başlıq/breadcrumb/nav metadata.
// Hər səhifə üçün dərhal düzgün <title>/breadcrumb — köhnə (məs. "Bazar")
// başlığın Mağazalar səhifəsində qalması problemini həll edir.

const SUFFIX = ' - ItemZo'

// pathname prefiksi → meta. Ən uzun uyğunluq qazanır.
const ROUTES = [
    { p: '/bazar',                title: 'Bazar',              section: 'Rəqəmsal məhsullar bazarı', nav: 'market',  desc: 'Rəqəmsal məhsullar, oyun hesabları və gift card bazarı.' },
    { p: '/market',               title: 'Bazar',              section: 'Rəqəmsal məhsullar bazarı', nav: 'market',  desc: 'Rəqəmsal məhsullar, oyun hesabları və gift card bazarı.' },
    { p: '/magazalar',            title: 'Mağazalar',          section: 'Etibarlı satıcı mağazaları', nav: 'shops',  desc: 'Itemzo-da etibarlı satıcıların mağazaları.' },
    { p: '/haftanin-firsatlari',  title: 'Həftənin Fürsətləri', section: 'Həftəlik seçilmiş fürsətlər', nav: 'market', desc: 'Bu həftənin seçilmiş endirim və fürsət elanları.' },
    { p: '/blogs',                title: 'Blog',               section: 'Bloq və məqalələr',        nav: 'blog',    desc: 'Itemzo bloq və məqalələri.' },
    { p: '/blog',                 title: 'Blog',               section: 'Bloq və məqalələr',        nav: 'blog',    desc: 'Itemzo bloq və məqalələri.' },
    { p: '/About',                title: 'Haqqımızda',         section: 'Itemzo haqqında',          nav: 'about',   desc: 'Itemzo platforması haqqında.' },
    { p: '/contact',              title: 'Əlaqə',              section: 'Bizimlə əlaqə',            nav: 'contact', desc: 'Itemzo ilə əlaqə.' },
    { p: '/fag',                  title: 'Tez-tez verilən suallar', section: 'FAQ',                nav: 'faq',     desc: 'Tez-tez verilən suallar.' },
    { p: '/reviews',              title: 'Rəylər',             section: 'İstifadəçi rəyləri',       nav: 'reviews', desc: 'Itemzo haqqında istifadəçi rəyləri.' },
    { p: '/support',              title: 'Dəstək Mərkəzi',     section: 'Dəstək',                   nav: '',        desc: 'Itemzo dəstək mərkəzi.' },
    { p: '/official',             title: 'Itemzo Rəsmi',       section: 'Rəsmi mağaza',             nav: 'market',  desc: 'Itemzo rəsmi top-up və e-pin mağazası.' },
    { p: '/satici-ol',            title: 'Satıcı ol',          section: 'Satıcı ol',                nav: '',        desc: 'Itemzo-da satıcı olun.' },
    { p: '/seller-hub',           title: 'Satıcı Paneli',      section: 'Satıcı imkanları',         nav: '',        desc: 'Satıcı panel imkanları.' },
    { p: '/',                     title: 'Ana səhifə',         section: 'Rəqəmsal məhsullar bazarı', nav: 'home',   desc: 'Itemzo — rəqəmsal məhsullar və oyun hesabları bazarı.' },
]

const DEFAULT_SECTION = 'Rəqəmsal məhsullar bazarı'

// pathname → meta obyekti. data ilə dinamik başlıq (mağaza/məhsul adı) verilə bilər.
export const getPageMeta = (pathname = '/', data = {}) => {
    const path = String(pathname || '/').toLowerCase()

    // Dinamik səhifələr — məlumat yüklənənə qədər düzgün generik başlıq.
    if (path.startsWith('/shop/') || path.startsWith('/magaza/')) {
        const name = data.storeName
        return { title: `${name || 'Mağaza'}${SUFFIX}`, section: name || 'Mağaza', nav: 'shops', breadcrumb: ['Ana səhifə', 'Mağazalar', name || 'Mağaza'], desc: data.description || 'Itemzo satıcı mağazası.' }
    }
    if (path.startsWith('/product/details/') || path.startsWith('/digital/product/')) {
        const name = data.productTitle
        return { title: `${name || 'Məhsul'}${SUFFIX}`, section: name || 'Məhsul', nav: 'market', breadcrumb: ['Ana səhifə', 'Bazar', name || 'Məhsul'], desc: data.description || 'Itemzo məhsul səhifəsi.' }
    }

    // Statik route — ən uzun prefiks uyğunluğu
    let match = null
    for (const r of ROUTES) {
        if (r.p === '/') continue
        if (path === r.p.toLowerCase() || path.startsWith(r.p.toLowerCase() + '/')) {
            if (!match || r.p.length > match.p.length) match = r
        }
    }
    if (!match && path === '/') match = ROUTES.find(r => r.p === '/')

    if (match) {
        return {
            title: `${match.title}${SUFFIX}`,
            section: match.section,
            nav: match.nav,
            breadcrumb: match.p === '/' ? ['Ana səhifə'] : ['Ana səhifə', match.title],
            desc: match.desc,
        }
    }

    // Naməlum route → 404
    return { title: `Səhifə tapılmadı${SUFFIX}`, section: DEFAULT_SECTION, nav: '', breadcrumb: ['Ana səhifə'], desc: '' }
}

// Header-in kiçik alt-başlığı üçün — cari route-un bölmə etiketi.
export const getHeaderSection = (pathname) => getPageMeta(pathname).section || DEFAULT_SECTION

export default getPageMeta
